import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FailedPaymentsSearchForm } from "../components/FailedPaymentsSearchForm";
import { FoundFailedPaymentsTable } from "../components/FoundFailedPaymentsTable";
import { disputeResolutionReducerActions, disputeResolutionSagaActions } from "..";
import { ReceiptGenerationResultModal } from "../components/ReceiptGenerationResultModal";
import { LoadingModal } from "../../UI/components/LoadingModal";


export function FailedPaymentReceiptGeneration() {


  const dispatch = useDispatch();

  const { disputeResolution } = useSelector(state => state);

  const { listLoading,actionsLoading, foundFailedPayments, pdfReceiptStr, receiptGeneratedStatus } = disputeResolution;

  const [showResult, setShowResult] = useState(false);
  const [selectedPaymentSearch, setSelectedPaymentSearch] = useState(null);
  const [searchedMobileNumber, setSearchedMobileNumber] = useState(null);

  const handleGenerateReceipt = (selectedPaymentSearch) => {

    setSelectedPaymentSearch(selectedPaymentSearch);

    dispatch(disputeResolutionSagaActions.createReceiptForFailedPayment(selectedPaymentSearch));

  };

  useEffect(() => {

    //don't show result initially. show only when status changes to success or fail
    if(receiptGeneratedStatus !== "unknown")
    {
      setShowResult(true);
    }

  },[receiptGeneratedStatus]);


  useEffect(() => {

    //reset on initial load
    dispatch(disputeResolutionReducerActions.failedPaymentsSearchReset());  

  },[dispatch]);

 

  const handleFailedPaymentsSearch = (mobileNumber) => {

    if(receiptGeneratedStatus === "unknown"){
      setSearchedMobileNumber(mobileNumber);
    }

    const search = {
      id:null,
      keyword: mobileNumber
    }

    dispatch(disputeResolutionSagaActions.searchFailedPayments(search));  
  };

  const downloadReceipt = (dataStr) => {
    if (dataStr && dataStr.length === 0){
      return;
    }
    const filename = `E-Receipt.pdf`;
    const link = document.createElement("a");
    let data = 'data:application/pdf;base64,' + dataStr;
    link.setAttribute("href", data);
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
    link.setAttribute("download", filename);
    link.click();
  };

  const handleDownloadReceipt = () =>{

    setShowResult(false);

    downloadReceipt(pdfReceiptStr?.base64ReportDoc);

    //reset datatable after updating one payment
    handleFailedPaymentsSearch(searchedMobileNumber);


  };

  const handleHideResultDialog = () => {
    setShowResult(false);

  }
  

  return (
    <div className="card card-custom card-stretch gutter-b">
      {/* begin::Header */}

      {/* end::Header */}

      {/* begin::Body */}

      
      <div className="card-body py-6">
        <div className="row justify-content-start">
          <div className="col-12">
            {/*<ReportSearchForm onHandleReportRequest={handleReportRequest} onHandleReset={handleReportReset} />*/}
            <FailedPaymentsSearchForm onFailedPaymentsSearch={handleFailedPaymentsSearch} />
          </div>
        </div>
        <div className="row pt-10">
          <div className="col-12">
            <FoundFailedPaymentsTable data={foundFailedPayments} listLoading={listLoading} onGenerateReceipt={handleGenerateReceipt} />
          </div>
        </div>
      </div>
      {/* end::Body */}
      <ReceiptGenerationResultModal 
        show={showResult} 
        status={receiptGeneratedStatus} 
        onDownloadReceipt={handleDownloadReceipt} 
        onHide={handleHideResultDialog} 
        selectedPaymentSearch = {selectedPaymentSearch}
      />
      <LoadingModal isLoading={listLoading || actionsLoading} text="Processing..." />
    </div>
  );
}
